export default __webpack_public_path__ + "static/media/Checklist.4f2ce334.svg";